



















import {Vue,Component} from "vue-property-decorator";
import BillingInfoSelectSection from "@/components/billing_info/SelectSection.vue";

@Component({
    components:{
        BillingInfoSelectSection
    }
})
export default class Result extends Vue {

}
